import PropTypes from 'prop-types';

function IFHomeInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M2.62065 11.3531C2.32762 14.3794 2.02925 22.723 2.62065 24.9661C2.78049 25.5629 27.3851 26.0317 27.3585 24.9661C27.172 17.2778 27.3585 8.7584 27.3585 8.7584C27.3585 8.7584 2.31696 6.80302 2.3436 8.2256C2.37024 9.64817 2.62065 11.3531 2.62065 11.3531Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.18288 7.71924C8.20126 8.19006 8.1244 8.65976 7.9569 9.10016C7.78939 9.54057 7.53471 9.94263 7.20809 10.2822C6.88147 10.6219 6.48966 10.892 6.05612 11.0766C5.62258 11.2611 5.15624 11.3563 4.68506 11.3563C4.21387 11.3563 3.74754 11.2611 3.314 11.0766C2.88046 10.892 2.48864 10.6219 2.16203 10.2822C1.83541 9.94263 1.58072 9.54057 1.41322 9.10016C1.24572 8.65976 1.16886 8.19006 1.18723 7.71924H8.18288Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.3008 7.71924C15.3192 8.19006 15.2423 8.65976 15.0748 9.10016C14.9073 9.54057 14.6526 9.94263 14.326 10.2822C13.9994 10.6219 13.6076 10.892 13.174 11.0766C12.7405 11.2611 12.2742 11.3563 11.803 11.3563C11.3318 11.3563 10.8655 11.2611 10.4319 11.0766C9.99838 10.892 9.60656 10.6219 9.27995 10.2822C8.95333 9.94263 8.69864 9.54057 8.53114 9.10016C8.36364 8.65976 8.28678 8.19006 8.30515 7.71924H15.3008Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.302 7.71924C22.302 8.64763 21.9332 9.53799 21.2767 10.1945C20.6203 10.8509 19.7299 11.2197 18.8015 11.2197C17.8731 11.2197 16.9828 10.8509 16.3263 10.1945C15.6698 9.53799 15.301 8.64763 15.301 7.71924H22.302Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.207 7.84717C29.207 8.77555 28.8382 9.66592 28.1818 10.3224C27.5253 10.9789 26.6349 11.3477 25.7065 11.3477C24.7782 11.3477 23.8878 10.9789 23.2313 10.3224C22.5749 9.66592 22.2061 8.77555 22.2061 7.84717H29.207Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.22036 0.398682C3.96828 0.760985 0.686245 7.7886 1.25101 7.78327C4.70888 7.7513 29.4148 8.76362 29.191 7.78327C28.8393 6.22217 27.0118 0.93148 25.2216 0.750329C23.4314 0.569177 5.22036 0.398682 5.22036 0.398682Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.07465 25.4135L12.9354 25.5787C12.9354 25.5787 13.0047 17.2883 12.9354 16.2973C12.7809 13.9477 7.98041 13.3562 7.2931 16.0416C7.0267 18.924 7.07465 25.4135 7.07465 25.4135Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M23.2237 15.3863C22.8347 15.3863 17.3629 14.9334 17.0432 15.3171C16.7235 15.7007 16.3612 19.9418 17.0432 20.1762C17.7252 20.4106 23.2663 20.8155 23.522 20.1762C23.7778 19.5368 24.3692 15.4449 23.2237 15.3863Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path d="M8.20947 8.15623L11.0919 0.398682" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
            <path d="M15.301 8.46538L15.61 0.595947" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
            <path d="M22.2061 8.52399L20.2827 0.595947" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
        </svg>
    );
}

export default IFHomeInactive;

IFHomeInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFHomeInactive.defaultProps = {
    className: null,
};
